import { useState, useEffect } from "react";
import {svgLibrary} from "./svg_library";

export function FormattedCategory({category, index=1}) {
  if (window.innerWidth > 500) {
    return (
      <div className="post-category" key={index}>
        {svgLibrary[category.toLowerCase().replaceAll(' ','_')]}{category}
      </div>
    );
  } else {
    return (
      <div className="post-category" key={index}>
        {svgLibrary[category.toLowerCase().replaceAll(' ','_')]}
      </div>
    );
  }
}
